import { getResourceName, Resource } from '../../../../common/resource/model'
import { ApplicationLogLevel, ScopeLogging } from '../../../../remote-api/models'

export enum LogLevel {
  TRACE = 'TRACE',
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
  FATAL = 'FATAL',
  OFF = 'OFF'
}

export type Connector = {
  id: string
  name: string
  icon: string
  packages: string[]
}

export type LogPointsConnector = {
  connector: Connector
  logLevel: LogLevel
  checked: boolean
  initialChecked: boolean
}

export type LogPointsConnectorsState = {[key: string]: LogPointsConnector}

export const LOG_LEVEL_OPTIONS: LogLevel[] = [
  LogLevel.TRACE,
  LogLevel.DEBUG,
  LogLevel.INFO,
  LogLevel.WARN,
  LogLevel.ERROR,
  LogLevel.FATAL,
  LogLevel.OFF
]

export type LogPointsApplicationsState = {
  logPointsConnectors: LogPointsConnectorsState
  logPointsConnectorsLoading: boolean
  logPointsConnectorsSaving: boolean
  hasSavedYet: boolean
  error?: string
}

export const getLogLevelWeight = (logLevel: LogLevel): number => {
  switch (logLevel) {
    case LogLevel.TRACE:
      return 1
    case LogLevel.DEBUG:
      return 2
    case LogLevel.INFO:
      return 3
    case LogLevel.WARN:
      return 4
    case LogLevel.ERROR:
      return 5
    case LogLevel.FATAL:
      return 6
    case LogLevel.OFF:
    default:
      return 7
  }
}

export const getMostRestrictiveLogLevel = (logLevels: LogLevel[]): LogLevel => {
  if (logLevels.length === 0) return LogLevel.INFO

  let result = logLevels[0]

  logLevels.forEach(logLevel => {
    if (getLogLevelWeight(logLevel) > getLogLevelWeight(result)) result = logLevel
  })

  return result
}

export const getAppLogLevelsByResource = (resource: Resource, appLogLevels: ApplicationLogLevel[]): {logLevels: ScopeLogging[], index: number} => {
  const resourceName = getResourceName(resource)

  const index = appLogLevels.findIndex(logLevel => logLevel.artifactName === resourceName)

  if (index > -1) return {logLevels: appLogLevels[index].scopeLoggingConfigurations, index}
  else return {logLevels: [], index}
}
